/* PWA service worker registration.
 * Only registers in production builds. The dev server's hot-reload
 * pipeline doesn't play well with service workers.
 */

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    window.location.hostname === "[::1]" ||
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

export function register({ onUpdate } = {}) {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }

  const publicUrl = new URL(process.env.PUBLIC_URL || "", window.location.href);
  if (publicUrl.origin !== window.location.origin) {
    return;
  }

  window.addEventListener("load", () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/service-worker.js`;

    if (isLocalhost) {
      checkValidServiceWorker(swUrl, onUpdate);
    } else {
      registerValidSW(swUrl, onUpdate);
    }
  });
}

function registerValidSW(swUrl, onUpdate) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      registration.onupdatefound = () => {
        const installing = registration.installing;
        if (!installing) return;
        installing.onstatechange = () => {
          if (
            installing.state === "installed" &&
            navigator.serviceWorker.controller
          ) {
            if (typeof onUpdate === "function") onUpdate(registration);
          }
        };
      };
    })
    .catch((err) => {
      console.warn("Service worker registration failed:", err);
    });
}

function checkValidServiceWorker(swUrl, onUpdate) {
  fetch(swUrl, { headers: { "Service-Worker": "script" } })
    .then((response) => {
      const ct = response.headers.get("content-type") || "";
      if (response.status === 404 || !ct.includes("javascript")) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => window.location.reload());
        });
      } else {
        registerValidSW(swUrl, onUpdate);
      }
    })
    .catch(() => {
      // Offline at boot — nothing to do.
    });
}

export function unregister() {
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => registration.unregister())
      .catch(() => {});
  }
}
